const consoleMessages = {
  showAxiosInterceptors: false,
  showLocalScriptLog: false,
  showLocalScriptError: false,
  showContractAssetsSubcatalogs: false,
  showEntityWorkflowTransitions: false,
  showFirebaseLog: false,
  showOfflineLog: false,
  showPersonsQuickAddRelations: false,
  showEligibility: false,
  showPageRender: false,
  showOidc: false,
}

export const setConsoleMessages = conf => {
  Object.assign(consoleMessages, conf?.consoleMessages || {})
}

export const reset = () => {
  for (const key in consoleMessages) consoleMessages[key] = false
}

export default consoleMessages
